import React, { useState } from 'react'

// This HoC add validation for input in our implementation of react-select
// If you need more validation rules - extend onInputChange
export const SelectWithValidation = ({
  component: Component,
  maxlength,
  ...props
}) => {
  const [inputError, setInputError] = useState('')

  if (!maxlength) {
    return <Component {...props} />
  }

  const validationConfig = {
    textFieldProps: {
      ...props.textFieldProps,
      error: props.textFieldProps.error || !!inputError,
      helperText: inputError,
    },
    onInputChange: (e) => {
      if (e.length > 50) {
        setInputError(
          `The tag is too long, maximum number of characters is ${maxlength}.`
        )
      } else {
        setInputError('')
      }
    },
  }

  if (!!inputError) {
    // To avoid overriding the default menuIsOpen value,
    // that is passed from react-select
    // react-select do not have callBack to control modal state
    // @ts-ignore
    validationConfig.menuIsOpen = !inputError
  }

  return <Component {...props} {...validationConfig} />
}
